export const ProvideKeys = Object.freeze({
  scrollableContainer: Symbol("scrollableContainer"),
});
